export interface MapTarget {
    latitude?: number | null;
    longitude?: number | null;
    location?: string | null;
}

function isIOSDevice(): boolean {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return true;
    // iPadOS 13+ reports as Macintosh; distinguish via touch support.
    const maxTouchPoints = (navigator as Navigator & { maxTouchPoints?: number }).maxTouchPoints;
    return /Macintosh/.test(ua) && typeof maxTouchPoints === "number" && maxTouchPoints > 1;
}

export function getMapLinkUrl(target: MapTarget): string | null {
    const { latitude, longitude, location } = target;
    const hasCoords = typeof latitude === "number" && typeof longitude === "number";

    if (isIOSDevice()) {
        if (hasCoords) {
            const label = location ? `&q=${encodeURIComponent(location)}` : "";
            return `https://maps.apple.com/?ll=${latitude},${longitude}${label}`;
        }
        if (location) return `https://maps.apple.com/?q=${encodeURIComponent(location)}`;
        return null;
    }

    if (hasCoords) return `https://www.google.com/maps?q=${latitude},${longitude}`;
    if (location)
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
    return null;
}

export function getMapEmbedUrl(target: MapTarget): string | null {
    const { latitude, longitude, location } = target;
    if (typeof latitude === "number" && typeof longitude === "number") {
        return `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
    }
    if (location) {
        return `https://maps.google.com/maps?q=${encodeURIComponent(location)}&z=14&output=embed`;
    }
    return null;
}
